import { render } from "./DotUnread.vue?vue&type=template&id=c512c178&scoped=true"
const script = {}

import "./DotUnread.vue?vue&type=style&index=0&id=c512c178&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c512c178"]])

export default __exports__